var routerActions = require('react-router-redux').routerActions;
var constants = require('../constants');
var api = require('../../../utils/api');
var messageUtils = require('../messageUtils');
var commonActions = require('../../common/actions/common');

var MessageCreateActions = (function(){

    var _createMessageSuccess = function(data){
        return {
            type: constants.MESSAGE_CREATE_SUCCESS,
            data: data
        }
    }

    var _createMessageError = function(error){
        return {
            type: constants.MESSAGE_CREATE_FAILURE,
            errors: error.data
        }
    }

    var _createMessage = function(formData, token){
        return function(dispatch){
            messageUtils.validate(formData)
                .then(function(result){
                    if(result === true){
                        api.post('/proxy/v1/admin/messages', _constructMessageData(formData), token)
                            .then(function(data) {
                                dispatch(_createMessageSuccess(data));
                                dispatch(routerActions.push('/admin/message-center'));
                            })
                            .catch(function(error) {
                                if(error.response){
                                    dispatch(_createMessageError(error.response));
                                }else{
                                    dispatch(commonActions.setGenericError('', error.message));
                                }
                            })
                    }else{
                        dispatch(_validationError(result));
                    }
                })
        };
    }

    var _requestMessage = function() {
        return {
            type: constants.REQUEST_MESSAGE
        };
    }

    var _receiveMessage = function(data) {
        return {
            type: constants.RECEIVE_MESSAGE,
            data: data
        };
    }

    var _fetchMessage = function(id, token) {
        return function (dispatch) {
            dispatch(_requestMessage());
            return api.get('/proxy/v1/admin/messages/' + id, token).then(function (response) {
                return response;
            }).then(function (data) {
                return dispatch(_receiveMessage(data));
            }).catch(function(error){
                if(error.response){
                    dispatch(commonActions.setGenericResponseError('', error.response));
                }else{
                    dispatch(commonActions.setGenericError('', error.message));
                }
            });
        };
    }

    var _shouldFetchMessage = function(state, id) {
        var messageData = state.message.messageData;
        if (Object.keys(messageData).length === 0) {
            return true;
        } else if(messageData._id === id) {
            return false;
        }else{
            return true;
        }
    }

    var _fetchMessageIfNeeded = function(id, token) {
        return function(dispatch, getState) {
            if (_shouldFetchMessage(getState(), id)) {
                return dispatch(_fetchMessage(id, token))
            }
        }
    }

    var _validationError = function(error){
        return {
            type: constants.VALIDATION_MESSAGE_ERROR,
            errors: error
        }
    }

    var _clearMessageError = function() {
        return {
            type: constants.CLEAR_MESSAGE_ERROR
        };
    }

    var _constructMessageData = function(formData){
        return {
            envelope: {
                subject: {
                    text: formData.subjectText || '',
                    image: formData.subjectImage || '' // url
                },
                title: formData.title || '',
                tags: formData.tagIDs, // tagID string array
                text: formData.text || '',
                action: {
                    image: formData.actionImage || '', // url
                    target: formData.actionTarget || '' // url
                }
            },
            meta: {
                target: formData.targetIDs, // targetID string array
                sendNotification: !!formData.sendPush || false,
                notification: {
                    text: formData.pushText || '',
                    deepLink: formData.pushLink || '', // uri, app will use this to open target section of it
                },
                context: {
                    id: '555397d24bcaae90b66b2274',
                    name: 'gi'
                }
            }
        };
    }

    var _changeSubjectText = function(subjectText){
        return {
            type: constants.CHANGE_SUBJECT_TEXT,
            subjectText: subjectText
        }
    }

    var _changeSubjectImage = function(subjectImage){
        return {
            type: constants.CHANGE_SUBJECT_IMAGE,
            subjectImage: subjectImage
        }
    }

    var _changeTitle = function(title){
        return {
            type: constants.CHANGE_TITLE,
            title: title
        }
    }

    var _addTag = function(tag){
        return function(dispatch, getState) {
            var state = getState();
            var tagIDs = state.message.messageData.tags || [];
            var resultTagIDs = messageUtils.removeHelper(tagIDs, tag._id);
            resultTagIDs.push(tag._id);

            return dispatch({
                type: constants.ADD_TAG,
                tagIDs: resultTagIDs
            })
        }
    }

    var _removeTag = function(tag){
        return function(dispatch, getState) {
            var state = getState();
            var tagIDs = state.message.messageData.tags || [];
            var resultTagIDs = messageUtils.removeHelper(tagIDs, tag._id);

            return dispatch({
                type: constants.REMOVE_TAG,
                tagIDs: resultTagIDs
            })
        }
    }

    var _changeText = function(text){
        return {
            type: constants.CHANGE_TEXT,
            text: text
        }
    }

    var _changeActionImage = function(actionImage){
        return {
            type: constants.CHANGE_ACTION_IMAGE,
            actionImage: actionImage
        }
    }

    var _changeActionTarget = function(actionTarget){
        return {
            type: constants.CHANGE_ACTION_TARGET,
            actionTarget: actionTarget
        }
    }

    var _addTarget = function(target){
        return function(dispatch, getState) {
            var state = getState();
            var targetIDs = (state.message.messageData.meta && state.message.messageData.meta.target) || [];
            var resultTargetIDs = messageUtils.removeHelper(targetIDs, target._id);
            resultTargetIDs.push(target._id);

            return dispatch({
                type: constants.ADD_TARGET,
                targetIDs: resultTargetIDs
            })
        }
    }

    var _removeTarget = function(target){
        return function(dispatch, getState) {
            var state = getState();
            var targetIDs = (state.message.messageData.meta && state.message.messageData.meta.target) || [];
            var resultTargetIDs = messageUtils.removeHelper(targetIDs, target._id);

            return dispatch({
                type: constants.REMOVE_TARGET,
                targetIDs: resultTargetIDs
            })
        }
    }

    var _changeTarget = function(target){
        return {
            type: constants.CHANGE_TARGET,
            targetIDs: [target._id]
        };
    }

    var _changeSendPush = function(sendPush){
        return {
            type: constants.CHANGE_SEND_PUSH,
            sendPush: sendPush
        }
    }

    var _changePushText = function(pushText){
        return {
            type: constants.CHANGE_PUSH_TEXT,
            pushText: pushText
        }
    }

    var _changePushLink = function(pushLink){
        return {
            type: constants.CHANGE_PUSH_LINK,
            pushLink: pushLink
        }
    }

    return {
        fetchMessage: _fetchMessage,
        fetchMessageIfNeeded: _fetchMessageIfNeeded,
        createMessage: _createMessage,
        clearMessageError: _clearMessageError,
        changeSubjectText: _changeSubjectText,
        changeSubjectImage: _changeSubjectImage,
        changeTitle: _changeTitle,
        addTag: _addTag,
        removeTag: _removeTag,
        changeText: _changeText,
        changeActionImage: _changeActionImage,
        changeActionTarget: _changeActionTarget,
        addTarget: _addTarget,
        removeTarget: _removeTarget,
        changeTarget: _changeTarget,
        changeSendPush: _changeSendPush,
        changePushText: _changePushText,
        changePushLink: _changePushLink
    }
})();

module.exports = MessageCreateActions;



// WEBPACK FOOTER //
// ./src/common/modules/message-center/actions/message-create.js